// @react
import React from 'react'
// @libraries
import clsx from 'clsx'
import { makeStyles, Theme } from '@material-ui/core/styles'
// @components
import Colors from '@bit/atd.web.colors'
import Container from '@bit/atd.web.container'
import Grid from '@bit/atd.web.grid'
import Button from '@bit/atd.web.button'
import Spacer from '@bit/atd.web.spacer'
import Icon from '@bit/atd.web.icons'
import colors from '@bit/atd.web.colors/dist/colors'
import Loader from '@bit/atd.web.loaders.base'

type PropsType = {
  exitLabel?: string
  exitDisable?: boolean
  nextLabel?: string
  nextPage?: string
  nextDisable?: boolean
  prevLabel?: string
  prevPage?: string
  prevDisable?: boolean
  handleExitOnClick?: () => void
  handlePrevOnClick?: () => void
  handleNextOnClick?: () => void
  isSubmitting?: boolean
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    maxWidth: '768px',
    margin: '0 auto',
  },
  exitButton: {
    padding: '32px 0',
  },
  center: {
    width: 'fit-content',
    margin: 'auto',
  },
  prevNextButtons: {
    padding: '16px 0',
    borderTop: `1px solid ${Colors.gray400}`,
    background: '#fff',
    [theme.breakpoints.down('xs')]: {
      position: 'sticky',
      bottom: 0,
      zIndex: '2',
    },
    '& p': {
      margin: '12px 0 0 0',
    },
  },
  prevNextButtons__prev: {
    background: '#fff',
  },
  prevNextButtons__next: {
    textAlign: 'right',
  },
  disabled: {},
}))

const Index = ({
  exitLabel,
  exitDisable,
  nextLabel,
  nextPage,
  nextDisable,
  prevPage,
  prevLabel,
  prevDisable,
  handleExitOnClick,
  handlePrevOnClick,
  handleNextOnClick,
  isSubmitting,
}: PropsType) => {
  /******************************************
   * HOOKS
   ******************************************/

  const classes = useStyles()

  /******************************************
   * FUNCTION
   ******************************************/

  const handleExitClick = () => {
    if (handleExitOnClick) handleExitOnClick()
  }

  const handlePrevClick = () => {
    if (handlePrevOnClick) handlePrevOnClick()
  }

  const handleNextClick = () => {
    if (handleNextOnClick) handleNextOnClick()
  }

  /******************************************
   * RENDER
   ******************************************/

  return (
    <>
      {handleExitOnClick ? (
        <>
          <div
            className={clsx(classes.exitButton, {
              [classes.disabled]: exitDisable,
            })}
          >
            <Container>
              <Grid className={classes.container} justify="center" container>
                <Grid item>
                  <Button
                    size="medium"
                    variant="tertiary"
                    onClick={() => handleExitClick()}
                    disabled={exitDisable}
                  >
                    {exitLabel ? exitLabel : 'Save and exit.'}
                  </Button>
                </Grid>
              </Grid>
            </Container>
          </div>
        </>
      ) : (
        <Spacer size={32} fullWidth />
      )}

      <div className={classes.prevNextButtons}>
        <Container>
          <Grid
            className={classes.container}
            container
            justify="space-between"
            alignItems="center"
          >
            <Grid
              className={clsx(classes.prevNextButtons__prev, {
                [classes.disabled]: prevDisable,
              })}
              xs={5}
              item
            >
              {handlePrevOnClick && (
                <>
                  <Button
                    size="medium"
                    variant="secondary"
                    disabled={prevDisable}
                    onClick={() => handlePrevClick()}
                  >
                    <>
                      <Icon
                        glyph="caret-left"
                        color={colors.ctaSecondary}
                        size={16}
                      />{' '}
                      {prevLabel ? prevLabel : 'Previous'}
                    </>
                  </Button>
                  <p>{prevPage ? prevPage : 'Previous Page'}</p>
                </>
              )}
            </Grid>
            <Grid item xs={2}>
              <div className={classes.center}>{isSubmitting && <Loader />}</div>
            </Grid>
            <Grid
              className={clsx(classes.prevNextButtons__next, {
                [classes.disabled]: nextDisable,
              })}
              xs={5}
              item
            >
              {handleNextOnClick && (
                <>
                  <Button
                    size="medium"
                    variant="primary"
                    disabled={nextDisable}
                    onClick={() => handleNextClick()}
                  >
                    <>
                      {nextLabel ? nextLabel : 'Next'}{' '}
                      <Icon
                        glyph="caret-right"
                        color={colors.white}
                        size={16}
                      />
                    </>
                  </Button>
                  <p>{nextPage ? nextPage : 'Next Page'}</p>
                </>
              )}
            </Grid>
          </Grid>
        </Container>
      </div>
    </>
  )
}

export default Index
